import { Link, SubItem } from "../SubItemTypes";

const sources: Link[] = [
  {
    link: "https://sumdu.edu.ua/uk/",
    name: "Sumy State University",
  },
];

export const items: SubItem[] = [
  {
    heading:
      "Master's degree in Computer Sciences (Information Technology of Design)",
    sources,
    terms: "01/10/2022 – 31/05/2024",
    links: [
      {
        link: "https://drive.google.com/file/d/1niXoH-CN4PbOM7LW5D63xH7C19m4wekH/view?usp=sharing",
        name: "Diploma link",
      },
    ],
  },
  {
    heading: "Bachelor's degree in Computer Sciences (Informatics)",
    sources,
    terms: "01/09/2018 – 30/06/2022",
    links: [
      {
        link: "https://drive.google.com/file/d/10N9RYL0K_2__duFIENx6bEYdYHxs7Pvz/view?usp=sharing",
        name: "Diploma link",
      },
    ],
  },
];
